module.exports = __webpack_public_path__ + "static/media/ic_pa_b3_fisdom.9998f315.svg";